      
// List Sub collections


// Load Make Type Model side Filter
function load_collection_make(url, handle) {
  $.getJSON(url, function(select_result) {
    $('.intial_loader_mtm').hide();
    if (select_result.data == null || select_result.data == undefined || select_result.data.length == 0 ) {
      $('.mtm_quick_filter').hide();
//       $('.quick--filter-container').html('No Data found for this collection');
//       return $('.quick--filter-container').show();
    };
    
    select_result.data.forEach(function(data, index){
      	//Desktop
    	$('#filter_make').append('<option value="'+data['slug']+'">'+data['name']+'</option>');
      	//Mobile
      	$('#filter_make_mobile').append('<option value="'+data['slug']+'">'+data['name']+'</option>');
    });
    $('.quick--filter-container').show();
  }).fail(function() {
    $('.mtm_quick_filter').hide();
//     $('.quick--filter-container').show();
//     $('.quick--filter-container').html('Unable to fetch information');
//     $('.intial_loader_mtm').hide();
  });
};

// Append MTM data
function append_mtm_data(data, id) {
  if (data == null || data == undefined) return null;

  data.forEach(function(type){
    $(id).append('<option value="'+type.slug+'">' + type.name +'</option>');
  });
};

function add_make_listner(handle){
  //Desktop
  $("#filter_make").change(function () {
    $('#filter_type').removeAttr("disabled");
    var Filter_make_val = $('#filter_make').val();
    $('#filter_type').empty();
    $('#filter_type').append('<option value="null">Select Type</option>');
    $('#filter_model').empty();
    $('#filter_model').append('<option value="null">Select Model</option>');

    if (Filter_make_val == "null") {
      $('#filter_type').attr("disabled",'disabled');
    } else {
      //$.getJSON('/apps/qfs-pim/collection/type/'+ handle + '/' + Filter_make_val, function(all_type_data) {
      $.getJSON('https://app.smalink.net/pim/collections.php?collection_mtm=collection-mtm-make&handle='+handle+'&make='+Filter_make_val, function(all_type_data) {
        append_mtm_data(all_type_data.data, '#filter_type');
      });
    }
  });
  
  //Mobile
  $("#filter_make_mobile").change(function () {
    $('#filter_type_mobile').removeAttr("disabled");
    var Filter_make_val_mobile = $('#filter_make_mobile').val();
    $('#filter_type_mobile').empty();
    $('#filter_type_mobile').append('<option value="null">Select Type</option>');
    $('#filter_model_mobile').empty();
    $('#filter_model_mobile').append('<option value="null">Select Model</option>');
    if (Filter_make_val_mobile == "null") {
      $('#filter_type_mobile').attr("disabled",'disabled');
    } else {
      //$.getJSON('/apps/qfs-pim/make/'+Filter_make_val_mobile, function(all_type_data) {
      $.getJSON('https://app.smalink.net/pim/collections.php?collection_mtm=collection-mtm-make&handle='+handle+'&make='+Filter_make_val_mobile, function(all_type_data) {
        append_mtm_data(all_type_data.makes, '#filter_type_mobile');
      });
    }
  });
};

function add_type_listner() {
  //Desktop
  $("#filter_type").change(function () {
    $('#filter_model').removeAttr("disabled");
    $('#filter_model').empty();
    $('#filter_model').append('<option value="null">Select Model</option>');
    var Filter_make_val = $('#filter_make').val();
    var Filter_type_val = $('#filter_type').val();

    if (Filter_type_val == "null") {
      $('#filter_model').attr("disabled",'disabled');
    } else {
      //$.getJSON('/apps/qfs-pim/make/'+Filter_make_val+'/types/'+Filter_type_val, function(all_model_data) {
      $.getJSON('https://app.smalink.net/pim/collections.php?collection_mtm=collection-mtm-type&handle='+handle+'&make='+Filter_make_val+'&type='+Filter_type_val, function(all_model_data) {
        append_mtm_data(all_model_data.makes, '#filter_model');
      });
    }
  });  
  
  //Mobile
  $("#filter_type_mobile").change(function () {
    $('#filter_model_mobile').removeAttr("disabled");
    $('#filter_model_mobile').empty();
    $('#filter_model_mobile').append('<option value="null">Select Model</option>');
    var Filter_make_val_mobile = $('#filter_make_mobile').val();
    var Filter_type_val_mobile = $('#filter_type_mobile').val();

    if (Filter_type_val_mobile == "null") {
      $('#filter_model_mobile').attr("disabled",'disabled');
    } else {
      //$.getJSON('/apps/qfs-pim/make/'+Filter_make_val_mobile+'/types/'+Filter_type_val_mobile, function(all_model_data) {
      $.getJSON('https://app.smalink.net/pim/collections.php?collection_mtm=collection-mtm-type&handle='+handle+'&make='+Filter_make_val_mobile+'&type='+Filter_type_val_mobile, function(all_model_data) {
        append_mtm_data(all_model_data.makes, '#filter_model_mobile');
      });
    }
  });
};

// Attributes Filter Data  


function attribute_content(attr, is_mobile) {
  let attr_id = is_mobile ? "attr_mobile_" : ''
  return '<li class="collection__filter-checkbox">'
  + '<div class="checkbox-wrapper">'
  
  + '<input type="checkbox" class="checkbox item_attribute" id='+ attr_id + attr.id + ' name=' + attr.value + ' value=' + attr.id +'>'
  + '<svg class="icon icon--check" viewBox="0 0 24 24" role="presentation">'
  + '<path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>'
  +  '</svg>'
  + '</div>'

  + '<label for=' + attr_id + attr.id + ' title=' + attr.name + ' >' + attr.value + '</label>'
  + '</li>';
};

function new_attr_content(counter, name, is_mobile) {
  let attr_id = is_mobile ? "attr_mobile_" : 'attr_'
  return '<div class="card__section card__section--tight collection-filter-card" >'
  +'<p class="card__title--small heading">'+ name +'</p>'
  +'<div class="collection__filter-group attribute--filter-container" id='+ attr_id + counter +'>' 
  +'<ul class="collection__filter-checkbox-list">'
  +'</ul>'
  +'</div>'
  +'</div>'
}

